module.exports = __webpack_public_path__ + "static/media/apartment22.5590d991.jpg";